import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";
import { Blog, BlogFormData } from "shared/types/blog";

const CreateBlogService = (data: BlogFormData) => {
  const formData = new FormData();
  formData.append("title", data.title);
  formData.append("content", data.content);
  if (data.thumbnail) {
    formData.append("image", data.thumbnail);
  }

  return HTTP_CLIENT.post(`${Endpoint.blog.createBlog}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const GetAllBlogsService = () => {
  return HTTP_CLIENT.get(`${Endpoint.blog.getBlogs}`);
};

const UpdateBlogService = (id: string, data: BlogFormData) => {
  const formData = new FormData();
  formData.append("title", data.title);
  formData.append("content", data.content);
  if (data.thumbnail) {
    formData.append("image", data.thumbnail);
  }

  return HTTP_CLIENT.patch(
    `${Endpoint.blog.updateBlog.replace(":id", id)}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

const DeleteBlogService = (id: string) => {
  return HTTP_CLIENT.delete(`${Endpoint.blog.deleteBlog.replace(":id", id)}`);
};

export {
  CreateBlogService,
  GetAllBlogsService,
  UpdateBlogService,
  DeleteBlogService,
};
